module.exports = __webpack_public_path__ + "static/img/office.25a19a6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/office.png
// module id = riKR
// module chunks = 1